import React from 'react'
import { useSelector } from 'react-redux'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'
import { ToastContainer } from 'react-toastify'
import AppRoutes from './routes/AppRoutes'
import UnAuthorizePage from './pages/unauthorized/Unauthorized'
import Login from './pages/login/Login'
import FirefighterLogin from './pages/firefighterLogin/FirefighterLogin'
import PageNotFound from './pages/pageNotFound/PageNotFound'
import { RootState } from './store/Store'
import ATLoader from './components/common/loader/ATLoader'
import { useFirefighterAuth } from './customHooks/auth/useFirefighterAuth'
import { useSSOAuth } from './customHooks/auth/useSSOAuth'
import { screens } from './utils/constants/UIConstants'

const App = () => {
  const { isLoading, authChecked } = useSSOAuth()

  const token = useSelector((state: RootState) => state?.atlas?.accessToken)
  const isFireFighterAccessEnabled = useSelector(
    (state: RootState) => state?.atlas?.isFireFighterAccessEnabled,
  )
  const isFirefighterLoading = useSelector(
    (state: RootState) => state?.atlas?.isFirefighterLoading,
  )
  const isAnythingLoading = useSelector((state: any) =>
    Object.values(state.apiService.queries).some(
      (entry: any) => entry.status === 'pending',
    ),
  )

  const isFirefighterPath = window.location.pathname === screens.firefighter

  useFirefighterAuth(isFirefighterPath)

  const getJSX = () => {
    // Still resolving firefighter config — render nothing
    if (isFireFighterAccessEnabled === null) return null

    // /firefighter is disabled by config and no active session — block access
    if (
      isFirefighterPath &&
      isFireFighterAccessEnabled === false &&
      !token &&
      !isLoading
    ) {
      return <PageNotFound />
    }

    // Firefighter mode (config true)
    if (isFireFighterAccessEnabled === true) {
      if (token) return <AppRoutes />
      // Suppress login form while a token refresh or MSAL resolution is in-flight
      if (isFirefighterLoading || isLoading) return null
      return <FirefighterLogin />
    }

    // SSO path — MSAL managed, only reached once mode is confirmed false
    return (
      <>
        {token && (
          <AuthenticatedTemplate>
            <AppRoutes />
          </AuthenticatedTemplate>
        )}
        {token == null && !isLoading && authChecked && <UnAuthorizePage />}
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </>
    )
  }

  return (
    <div className="app">
      {getJSX()}
      <ToastContainer pauseOnFocusLoss={false} />
      {isAnythingLoading && <ATLoader />}
    </div>
  )
}

export default App
